import React, { useCallback } from 'react';

import { FormField } from '@gogame/form';
import { useChildComponent } from '@gogame/hooks-ts';

import AddTag from 'scenes/GalleryTags/components/AddTag';

import { CategoryFormCreate } from '../CategoryForm';

const TagsMultiSelect = ({ withAddTags = true, ...props }) => {
  const [childComponent, openChildComponent] = useChildComponent();
  const handleOpenCreateCategoryForm = async (onSubmit) => {
    const result = await new Promise((resolve, reject) => {
      openChildComponent(CategoryFormCreate, {
        onClose: reject,
        onSubmit: resolve,
      });
    });

    return onSubmit(result.tags);
  };
  const handleAdd = useCallback(async () => {
    return await new Promise((resolve, reject) => {
      openChildComponent(AddTag, {
        onClose: reject,
        onSubmit: resolve,
        onAddCategory: () => handleOpenCreateCategoryForm(resolve),
      });
    });
  }, [openChildComponent]);

  return (
    <React.Fragment>
      <FormField.MultiSelect
        label={'Internal Tags'}
        addOptionLabel={'Internal Tags'}
        onAdd={withAddTags ? handleAdd : null}
        multipleAdd={true}
        padding={0}
        {...props}
      />
      {childComponent}
    </React.Fragment>
  );
};
export default TagsMultiSelect;
